import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { updateStateForId } from "../../../helpers/updateState";
import {
  serviceEliminarUsuario,
  serviceInhabilitarUsuario,
} from "../../../services/usuarios/usuarioService";
import {
  lenguage,
  optionsTable,
  tableIcons,
} from "../../structure/config-datatable";
import { UsuarioEditModal } from "./edit-modal/UsuarioEditModal";
import "./DatatableUsers.css";

export const DatatableUsers = () => {
  const dispatch = useDispatch();
  const [modalEditar, setmodalEditar] = useState(false);
  const [edit, setEdit] = useState({});
  const [state, setState] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //PETICION HTTP USEEFFECT
  useEffect(() => {
    async function getData() {
      const url = `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/dashboard/users`;
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "x-token": localStorage.getItem("token"),
        },
      });
      const respuesta = await resp.json();

      if (resp.ok) {
        const uniqueUsers = respuesta.usuarios.filter(
          (user, index, self) =>
            index === self.findIndex((u) => u.id === user.id),
        );
        setState(uniqueUsers);
        setIsLoading(false);
      } else {
        if (respuesta.msg === undefined) {
          Swal.fire("Error", respuesta.errors[0].msg, "error");
        } else {
          Swal.fire("Error", respuesta.msg, "error");
        }
      }
    }
    getData();
  }, [setState]);

  useEffect(() => {
    async function getData() {
      const url = `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/datos/ciudades`;
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "x-token": localStorage.getItem("token"),
        },
      });
      const respuesta = await resp.json();

      if (resp.ok) {
        setCiudades(respuesta.ciudades);
        console.log("ciudades", respuesta.ciudades);
      } else {
        if (respuesta.msg === undefined) {
          Swal.fire("Error", respuesta.errors[0].msg, "error");
        } else {
          Swal.fire("Error", respuesta.msg, "error");
        }
      }
    }
    getData();
  }, [setCiudades]);

  useEffect(() => {
    async function getData() {
      const url = `${process.env.REACT_APP_MI_VARIABLE_DE_ENTORNO}/api/datos/roles`;
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          "x-token": localStorage.getItem("token"),
        },
      });
      const respuesta = await resp.json();

      if (resp.ok) {
        setRoles(respuesta.roles);
      } else {
        if (respuesta.msg === undefined) {
          Swal.fire("Error", respuesta.errors[0].msg, "error");
        } else {
          Swal.fire("Error", respuesta.msg, "error");
        }
      }
    }
    getData();
  }, [setRoles]);
  console.log(roles);
  //===========CONFIG TABLE ============================================

  // Helper function to get nombre based on role
  const getNombre = (rowData) => {
    const rol = rowData.Role?.rol || "";

    if (rol === "Cliente") {
      // For Cliente, use contador.nombre
      const nombre = rowData.contador?.nombre;
      return nombre && nombre !== "NA" ? nombre : "N/A";
    } else if (rol === "Usuario") {
      // For Usuario, use cliente.razon_social first, fallback to contador.nombre
      const clienteNombre = rowData.cliente?.razon_social;
      const contadorNombre = rowData.contador?.nombre;

      if (clienteNombre && clienteNombre !== "NA") return clienteNombre;
      if (contadorNombre && contadorNombre !== "NA") return contadorNombre;
      return "N/A";
    } else if (rol === "Auxiliar") {
      // For Auxiliar, use contador.nombre or auxiliar.nombre
      const contadorNombre = rowData.contador?.nombre;
      const auxiliarNombre = rowData.auxiliar?.nombre;

      if (contadorNombre && contadorNombre !== "NA") return contadorNombre;
      if (auxiliarNombre && auxiliarNombre !== "NA") return auxiliarNombre;
      return "N/A";
    }
    return "N/A";
  };

  // Helper function to get telefono based on role
  const getTelefono = (rowData) => {
    const rol = rowData.Role?.rol || "";

    if (rol === "Cliente") {
      // For Cliente, use contador.telefono
      const telefono = rowData.contador?.telefono;
      return telefono && telefono !== "NA" ? telefono : "-";
    } else if (rol === "Usuario") {
      // For Usuario, use cliente.telefono first, fallback to contador.telefono
      const clienteTelefono = rowData.cliente?.telefono;
      const contadorTelefono = rowData.contador?.telefono;

      if (clienteTelefono && clienteTelefono !== "NA") return clienteTelefono;
      if (contadorTelefono && contadorTelefono !== "NA")
        return contadorTelefono;
      return "-";
    } else if (rol === "Auxiliar") {
      // For Auxiliar, use contador.telefono or auxiliar.telefono
      const contadorTelefono = rowData.contador?.telefono;
      const auxiliarTelefono = rowData.auxiliar?.telefono;

      if (contadorTelefono && contadorTelefono !== "NA")
        return contadorTelefono;
      if (auxiliarTelefono && auxiliarTelefono !== "NA")
        return auxiliarTelefono;
      return "-";
    }
    return "-";
  };

  // Helper function to render cities
  const getCiudades = (rowData) => {
    const ciudades = rowData.Ciudades || [];
    if (ciudades.length === 0) return "Sin ciudades";
    return ciudades.map((c) => c.ciudad).join(", ");
  };

  // Helper function to get estado value
  const getEstadoValue = (rowData) => {
    const estado = rowData.estado;
    // Handle string "1"/"0", number 1/0, and boolean true/false
    return estado === "1" || estado === 1 || estado === true;
  };

  const acciones = [
    {
      icon: () => <tableIcons.Edit style={{ color: "#FFC007" }} />,
      tooltip: "Editar",
      onClick: (e, rowData) => {
        setmodalEditar(true);
        setEdit(state.find((user) => user.id === rowData.id));
      },
    },
    {
      icon: () => <tableIcons.Clear style={{ color: "#DC3444" }} />,
      tooltip: "Inhabilitar",
      onClick: (e, rowData) =>
        onInhabilitarUsuario(state.find((user) => user.id === rowData.id)),
    },
    {
      icon: () => <tableIcons.Delete style={{ color: "#DC3444" }} />,
      tooltip: "Eliminar Usuario",
      onClick: (e, rowData) => {
        Swal.fire({
          title: "¿Está seguro?",
          text: "Recuerde que el usuario, junto con sus usuarios asociados y tareas, será eliminado completamente del sistema. Esta acción es irreversible y no es posible recuperar la información. Si desea acceder nuevamente, deberá registrarse otra vez.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "Eliminando...",
              text: "Por favor espere.",
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            onEliminarUsuario(state.find((user) => user.id === rowData.id))
              .then(() => {
                Swal.close();
                Swal.fire(
                  "Eliminado",
                  "El usuario ha sido eliminado correctamente.",
                  "success",
                );
              })
              .catch(() => {
                Swal.close();
                Swal.fire(
                  "Error",
                  "Hubo un problema al eliminar el usuario.",
                  "error",
                );
              });
          }
        });
      },
    },
  ];

  //CREACION DE LAS COLUMNAS QUE SE VAN A MOSTRAR
  const columnas = [
    {
      title: "Codigo",
      field: "id",
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "Nombre",
      render: (rowData) => getNombre(rowData),
    },
    {
      title: "Telefono",
      render: (rowData) => getTelefono(rowData),
    },
    {
      title: "Rol",
      render: (rowData) => rowData.Role?.rol || "N/A",
    },
    {
      title: "Ciudades",
      render: (rowData) => getCiudades(rowData),
    },
    {
      title: "Estado",
      render: (rowData) =>
        getEstadoValue(rowData) ? (
          <tableIcons.Check style={{ color: "green" }} />
        ) : (
          <tableIcons.Clear style={{ color: "red" }} />
        ),
    },
  ];
  const data = state;

  const onEliminarUsuario = async (user) => {
    const respuesta = await dispatch(
      serviceEliminarUsuario(user.id, user.email),
    );
    console.log("respuesta", respuesta);

    if (respuesta === true) {
      const newArray = state.filter((item) => item.id !== user.id);
      setState([...newArray]);
    } else {
      if (respuesta.msg === undefined) {
        Swal.fire("Error", respuesta.errors[0].msg, "error");
      } else {
        Swal.fire("Error", respuesta.msg, "error");
      }
    }
  };

  // FUNCTION ==================================
  const onInhabilitarUsuario = async (user) => {
    const respuesta = await dispatch(serviceInhabilitarUsuario(user.id));
    const newArray = updateStateForId(state, respuesta);
    setState([...newArray]);
  };
  // FIN FUNCTION ==================================

  return (
    <>
      {!isLoading ? (
        <div className="card-body">
          <div>
            <MaterialTable
              icons={tableIcons}
              columns={columnas}
              data={data}
              title={""}
              options={optionsTable}
              localization={lenguage}
              actions={acciones}
              // detailPanel={rowData => {
              //     return (
              //         <div>
              //             <h1>{rowData.genero}</h1>
              //         </div>)
              // }}
            />

            <UsuarioEditModal
              setmodalEditar={setmodalEditar}
              modalEditar={modalEditar}
              editar={edit}
              state={state}
              setState={setState}
              ciudades={ciudades}
              roles={roles}
            />
          </div>
        </div>
      ) : (
        <div
          className="card-body"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <div className="loader-carga"></div>
        </div>
      )}
      {/* <FooterCard
                setmodalEditar={setmodalEditar}
                modalEditar={modalEditar}
                texto={"Crear Usuario"}
                editar={edit}
                state={state}
                setState={setState}
                modalKey={"usuario"} /> */}
    </>
  );
};
